const getVerifyData = state => state.verifyModal;

export { getVerifyData };
